import {
    GET_EOGRE,
    GET_EOGRE_SUCCESS,
    GET_EOGRE_FAIL,
} from '../../constants/globalProfileConstants/eogreConstants';

/**
 * Reducer function for managing eogre list state.
 *
 * This reducer handles actions related to fetching eogre data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the eogre list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const eogreReducer = (state = { eogreList: {} }, action) => {
    switch (action.type) {
        case GET_EOGRE:
            return {
                loading: true,
            };
        case GET_EOGRE_SUCCESS:
            return {
                loading: false,
                eogreList: action.payload,
            };
        case GET_EOGRE_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
